import React from 'react';

import { Box, CircularProgress } from '@mui/material';

import ModeGraphicModalFilter from './ModeGraphicModalFilter';
import ExcelTable from './ExcelTable';
import IndicatorDynamicTable from './components/IndicatorDynamicTable';

// Render the component
const ModeGraphicModalContent = ({
  setEndDate,
  startDate,
  endDate,
  setStartDate,
  downloadExcel,
  loadingExcel,
  loadingLabels,
  searchCampaigns,
  loadingSearch,
  fetchDataToNewTable,
  openCampaignAnalysis,
  loadingTable,
  showNewTable,
  excelColumns,
  setExcelColumns,
  rows,
  setRows,
  columns,
  campaigns,
  loading,
  page,
  setPage,
  rowsPerPage,
  totalItems,
  themeColors,
  sentMessagesLength,
  setSentMessagesLength,
  totalApiPages,
  setTotalApiPages,
  dynamicTableCampaignName,
}) => {
  return (
    <Box
      component="div"
      sx={{
        minHeight: '100%',
        minWidth: '100%',
        maxHeight: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        justifyContent: 'start',
        overflow: 'auto',
        padding: '0px',
      }}
    >
      {showNewTable && loadingTable === false ? null : (
        <ModeGraphicModalFilter
          setEndDate={setEndDate}
          startDate={startDate}
          endDate={endDate}
          setStartDate={setStartDate}
          downloadExcel={downloadExcel}
          loadingExcel={loadingExcel}
          loadingLabels={loadingLabels}
          searchCampaigns={searchCampaigns}
          loadingSearch={loadingSearch}
          fetchDataToNewTable={fetchDataToNewTable}
          loadingTable={loadingTable}
        />
      )}

      {showNewTable ? (
        loadingTable ? (
          <Box
            sx={{
              width: '100%',
              height: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <CircularProgress style={{ color: themeColors.purple500 }} />
          </Box>
        ) : (
          <ExcelTable
            columns={excelColumns}
            setColumns={setExcelColumns}
            endDate={endDate}
            rows={rows}
            setRows={setRows}
            startDate={startDate}
            sentMessagesLength={sentMessagesLength}
            setSentMessagesLength={setSentMessagesLength}
            totalApiPages={totalApiPages}
            setTotalApiPages={setTotalApiPages}
            campaignFilterName={dynamicTableCampaignName}
          />
        )
      ) : (
        <IndicatorDynamicTable
          columns={columns}
          data={campaigns}
          onPageChange={(event, newPage) => setPage(newPage)}
          loading={loading}
          page={page}
          rowsPerPage={rowsPerPage}
          totalItems={totalItems}
          selectedLabel={''}
          onOpenCampaignAnalysis={openCampaignAnalysis}
          loadingAnalysis={loadingTable}
        />
      )}
    </Box>
  );
};

export default ModeGraphicModalContent;
